import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import { DistributorForm } from '../../services/types';
import { useHistory } from 'react-router-dom';

export default function useUpdateDistributor() {
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  async function execute(data: DistributorForm, distributorId: string) {
    try {
      setLoading(true);
      const response = await api.put(
        `v1/backoffice/distributors/${distributorId}`,
        {
          name: data.name,
          cnpj: data.cnpj,
          zipCode: data.zipCode,
          state: data.state,
          city: data.city,
          neighborhood: data.neighborhood,
          streetAddress: data.streetAddress,
          streetNumber: data.streetNumber,
          stateRegistration: data.stateRegistration,
          feeType: data.feeType,
          complement: data.complement,
          email: data.email,
          phone: data.phone,
          cellPhone: data.cellPhone,
          fee: Number(data.fee),
        },
      );

      if (response.status === 200) {
        toast.success(ToastMessages.distributor.success.updateDistributor);
        history.push('/home/companies');
        return;
      }
    } catch (error) {
      toast.error(ToastMessages.distributor.error.updateDistributor);
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
